// extracted by mini-css-extract-plugin
module.exports = {"dl":"ShippingAddressDetail_dl__3uXOe","dt":"ShippingAddressDetail_dt__3CPTm","dd":"ShippingAddressDetail_dd__3iDI_"};